import { flow, applySnapshot } from 'mobx-state-tree';
import { toMapById } from '~/mst/utils';
import api from '~/api';
import type { IMapWidgetModel } from './model';

export default (self: IMapWidgetModel) => ({
  fetch: flow(function* fetch(params: { from?: number; to?: number; [key: string]: unknown } = {}) {
    try {
      self.startFetching();
      const { from, to, ...rest } = params;
      const { data } = yield self.sync(api.search.nodes, {
        type: 'thiamis',
        includes: ['configuration', 'profiles'],
        node_id: self.node_id,
        ...(from ? { from, ...(to && { to }) } : { last: 1 }),
        ...rest
      });
      applySnapshot(self.nodes, {
        models: toMapById(data)
      });
      self.finishFetching();
    } catch (error) {
      self.failFetching(error);
    }
  })
});
